import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { BreadcrumbComponent } from '../../elements/breadcrumb/breadcrumb.component';
import { PaginationComponent } from '../../elements/pagination/pagination.component';
import { MatSortModule, Sort } from '@angular/material/sort';
import { LoadingService } from '../../services/loading.service';
import { AbstractControl, FormArray, FormBuilder, FormGroup, FormsModule, NgForm, ReactiveFormsModule, ValidatorFn } from '@angular/forms';
import { Offcanvas } from 'bootstrap';
import { Select2, Select2Data } from 'ng-select2-component';
import { MatSelectModule } from '@angular/material/select';
import { NgFor, NgIf } from '@angular/common';
import { HttpServiceService } from '../../services/http-service.service';
import { NgxToastrService } from '../../_services/ngx-toastr/ngx-toastr.service';
import { Subject } from 'rxjs/internal/Subject';
import { debounceTime, filter, switchMap, tap } from 'rxjs';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-property-invoice',
  imports: [BreadcrumbComponent, PaginationComponent, MatSortModule, ReactiveFormsModule, MatSelectModule, NgIf, NgFor, FormsModule, NgSelectModule],
  templateUrl: './property-invoice.component.html',
  styleUrl: './property-invoice.component.css'
})
export class PropertyInvoiceComponent {
  breadcrumbList = {
    breadcrumb_path: 'Dashboard',
    currentURL: 'Invoices',
    breadcrumb_url : ''
  }
  active = 1;
  page: any = 1;
  totalRows: number = 5;
  totalPage: any = 0;
  allData: any = [];
  orderData: any[] = [];
  allInvoices: any[] = [];
  property_invoice: boolean = false;
  loadingService = inject(LoadingService);
  addInvoiceForm!: FormGroup;
  @ViewChild('addInvoiceButton') offcanvas!: ElementRef;
  private offcanvasInstance: Offcanvas | null = null;
  properties: Select2Data = [];
  filteredItems: any[] = [];
  allBills : any[] = [{
    bill_name : "test",
    bill_amount : 1000,
    bill_type : "Testing",
    bill_uid : "123456"
  },
  {
    bill_name : "test1",
    bill_amount : 2000,
    bill_type : "Testing1",
    bill_uid : "123457"
  }];
  searchInput$ = new Subject<string>();
  offset_limit : number = 20;
  propertiesList : any = [];
  hasMore : boolean = true;
  lastSearchTerm :any;

  constructor(private fb: FormBuilder, private httpService : HttpServiceService, private alertService: NgxToastrService){
    this.orderData = this.allInvoices.slice();
    this.addInvoiceForm = this.fb.group({
      searchText : [''],
      selectedBill : [null],
      bills : this.fb.array(this.allBills.map(() => this.fb.control(false)),
      this.minOneCheckboxChecked())
    })
  }

  ngOnInit(): void {
    this.getAllProperties();
    this.totalRows = 10;
    this.allData = this.paginator(this.orderData, this.page, this.totalRows);
    this.totalPage = this.allData.total_pages;
    this.filteredItems = this.allBills;

    this.searchInput$
      .pipe(
        debounceTime(300),
        filter(term => {
        const skip = term === this.lastSearchTerm || !term;
        return !skip;
      }),
        tap((term) => {
          this.page = 1;
          this.hasMore = true;
          this.lastSearchTerm = term;
        }),
        switchMap(term =>{
          return this.httpService.getAllProperties(1, 20, "&name="+term);
        }
        )
      )
      .subscribe(results => {
        this.propertiesList = results.data["properties"] ?? [];
        if(this.propertiesList.length >= results.data["total"]){
          this.hasMore = false;
        }
        for(let resp of this.propertiesList){
        this.properties.push(
          {
                value: resp.uid,
                label: resp.name,
                data: { name: resp.name }
          }
        )
       }
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const offcanvasElement = this.offcanvas?.nativeElement;
      if (offcanvasElement) {
        this.offcanvasInstance = Offcanvas.getOrCreateInstance(offcanvasElement, {
          backdrop: 'static',
          keyboard: false,
        });
      }
    });
  }

  getAllProperties(query : any = ''){
    this.httpService.getAllProperties(this.page, this.offset_limit).subscribe({
      next : (response) => {
        this.propertiesList = response.data["properties"] ?? [];
        if(this.propertiesList.length >= response.data["total"]){
          this.hasMore = false;
        }
        this.properties = [];
        for(let resp of this.propertiesList){
        this.properties.push(
          {
                value: resp.uid,
                label: resp.name,
                data: { name: resp.name }
          }
        )
       }
      }
    })
  }

  onScrollToEnd() {
    // Optional: For pagination / infinite scroll
    if (!this.hasMore) return;
    this.page+=1;
    this.offset_limit+=20;
    this.httpService.getAllProperties(this.page, this.offset_limit).subscribe(response => {
      let resp = response.data["properties"] ?? [];
      if(this.propertiesList.length >= response.data["total"]){
          this.hasMore = false;
      }
      this.propertiesList = [...this.propertiesList, ...resp];
      this.properties = [];
      for(let resp of this.propertiesList){
        this.properties.push(
          {
                value: resp.uid,
                label: resp.name,
                data: { name: resp.name }
          }
        )
       }
    });
  }

  minOneCheckboxChecked(): ValidatorFn {
    return (control: AbstractControl) => {
      const formArray = control as FormArray;
      return formArray.controls.some(ctrl => ctrl.value) ? null : { required: true };
    };
  }

  filterItems() {
    const control = this.addInvoiceForm?.get("searchText");
    if (!control?.value) {
      this.filteredItems = this.allBills;
    } else {
      this.filteredItems = this.allBills.filter(item =>
        item.bill_name.toLowerCase().includes(control?.value?.toLowerCase()) ||
         item.bill_type.toLowerCase().includes(control?.value?.toLowerCase()) ||
         item.bill_amount.toString().includes(control?.value)

      );
    }
  }

  getSelectedPermissions() {
    const selectedItems: string[] = [];
    this.allFormControls.controls.forEach((control, index) => {
      if (control.value) {
        selectedItems.push(this.allBills[index].uid);
      }
    });
    return selectedItems;
  }

  toggleInvoice(){
    this.property_invoice = !this.property_invoice;
  }

  addInvoicePopup(data : any){
    this.toggleInvoice();
    if (this.offcanvasInstance) {
      this.offcanvasInstance.show();
    }
  }

  invoiceClose(){
    this.toggleInvoice();
    if (this.offcanvasInstance) {
      this.offcanvasInstance.hide();
    }
  }

  onSubmit(){

  }

  sortData(sort: Sort) {
    const data = this.allInvoices.slice();
    if (!sort.active || sort.direction === '') {
      this.orderData = data;
      return;
    }

    this.orderData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'bill_name': return compare(a.bill_name, b.bill_name, isAsc);
        case 'bill_type': return compare(a.bill_type, b.bill_type, isAsc);
        case 'bill_amount': return compare(a.bill_amount, b.bill_amount, isAsc);
        case 'created_at': return compare(a.created_at, b.created_at, isAsc);
        case 'status': return compare(a.status, b.status, isAsc);
        default: return 0;
      }
    });
    this.allData = this.paginator(this.orderData, this.page, this.totalRows);
  }

  pageChange(e: any) {    //  Page Change funcation   ---------
    if(this.page == e) return;
    this.page = e;
    this.allData = this.paginator(this.orderData, this.page, this.totalRows);
    this.totalPage = this.allData.total_pages;
  }

  paginator(items: any, current_page: any, per_page_items: any) {
    let page = current_page || 1,
      per_page = per_page_items || 10,
      offset = (page - 1) * per_page,

      paginatedItems = items.slice(offset).slice(0, per_page_items),
      total_pages = Math.ceil(items.length / per_page);

    return {
      page: page,
      per_page: per_page,
      pre_page: page - 1 ? page - 1 : null,
      next_page: (total_pages > page) ? page + 1 : null,
      total: items.length,
      total_pages: total_pages,
      data: paginatedItems
    };
  }

  get allFormControls() {
    return this.addInvoiceForm?.get('bills') as FormArray;
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
